import React, { FC } from 'react';
import * as S from './WhatsAppButton.style';
import whatsappIcon from 'Assets/whatsapp.svg';

type TProps = {
  phone: string;
  message?: string;
};

export const WhatsAppButton: FC<TProps> = ({ phone, message = '' }) => {
  const cleanPhone = phone.replace(/\D/g, '');
  const href = `https://wa.me/${cleanPhone}${
    message ? `?text=${encodeURIComponent(message)}` : ''
  }`;

  return (
    <S.Wrapper
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp öffnen"
    >
      <S.Icon src={whatsappIcon} alt="" />
    </S.Wrapper>
  );
};
